import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { formatPrice } from "@/lib/format";

export default function ProductCard({ item }) {
  const { t } = useTranslation();
  const { user, favIds, toggleFavorite } = useAuth();
  const navigate = useNavigate();
  const isFav = favIds?.has(item.id);
  const isSold = item.status === "sold";

  const onFav = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user || !user.id) {
      navigate("/login");
      return;
    }
    try {
      const now = await toggleFavorite(item.id);
      const el = e.currentTarget.querySelector("svg");
      if (el) {
        el.classList.remove("heart-pop");
        void el.offsetWidth;
        el.classList.add("heart-pop");
      }
      if (now) toast.success("♡");
    } catch {
      toast.error("!");
    }
  };

  const img = (item.images && item.images[0]) || "https://images.pexels.com/photos/15120548/pexels-photo-15120548.jpeg?auto=compress&cs=tinysrgb&w=940";

  return (
    <Link to={`/item/${item.id}`} data-testid={`product-card-${item.id}`} className="group block">
      <div className="relative overflow-hidden rounded-xl bg-muted aspect-[3/4]">
        <img
          src={img}
          alt={item.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
        />
        {isSold && (
          <div className="absolute inset-0 bg-background/70 flex items-center justify-center">
            <span className="px-3 py-1 rounded-full bg-foreground text-background text-xs uppercase tracking-widest">
              {t("condition.new") /* placeholder to force retranslate */ ? "" : ""}Sold
            </span>
          </div>
        )}
        <button
          onClick={onFav}
          data-testid={`fav-btn-${item.id}`}
          aria-label="fav"
          className="absolute top-2.5 right-2.5 w-9 h-9 rounded-full bg-background/85 backdrop-blur flex items-center justify-center hover:bg-background transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
        >
          <Heart className={`w-4 h-4 ${isFav ? "fill-primary text-primary" : "text-foreground"}`} />
        </button>
      </div>

      <div className="mt-3 space-y-0.5">
        <div className="flex items-baseline justify-between gap-2">
          <div className="font-semibold text-[15px] leading-tight">
            {formatPrice(item.price)}
          </div>
          {item.size && (
            <div className="text-xs text-muted-foreground uppercase tracking-wider">
              T.{item.size}
            </div>
          )}
        </div>
        {item.brand && (
          <div className="text-sm text-muted-foreground truncate">{item.brand}</div>
        )}
        <div className="text-xs text-muted-foreground truncate">
          {t(`condition.${item.condition}`, { defaultValue: item.condition })}
        </div>
      </div>
    </Link>
  );
}
